// ======================================================================
// File Name       : ItemConstant
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ModalIds from './ModalIds';

export const PUBLIC_STATUS = {
  PRIVATE: 0,
  PUBLIC: 1,
};

export const END_CONDITION_TYPE_FOR_ITEM = {
  NOT_CONDITION: 0,
  ACHIVEMENT_RATE: 1,
};

export const CHOSEN_THUMBNAIL_CONTENT = {
  DEFAULT: 0,
  MANUAL: 1,
  NOTHING: -1,
};

// sprint_20230522_tma START
export const START_CONDITION_TYPE_FOR_ITEM = {
  NO_CONDITION: 0,
  AND_CONDITION: 1,
  OR_CONDITION: 2,
  ACHIEVEMENT_RATE_CONDITION: 3,
};

export const START_CONDITION_TYPE_FOR_BOX = {
  NO_CONDITION: 0,
  AND_CONDITION: 1,
  OR_CONDITION: 2,
  ACHIEVEMENT_RATE_CONDITION: 3,
};
// sprint_20230522_tma END
